// Module
var code = "<div class=\"accessible-skip-link\" ng-repeat=\"option in $ctrl.options\"><a ng-if=\"option.domElement\" role=\"link\" class=\"goreact-btn primary-btn skip-link-btn\" ng-href=\"#{{option.id}}\">{{option.linkText}}</a></div>";
// Exports
module.exports = code;